<template>
	<div class="password-app">
		<div class="password">
			<div class="user-title">
				<span>修改密码</span>
			</div>
			<el-form  @submit.native.prevent  :model="form"  ref='Verify'  :rules="formRule">
				<el-form-item  prop="phone"   >
					<el-input
						v-model="form.phone"
						placeholder="请输入手机号码"
					></el-input>
		
				</el-form-item>
				<el-form-item
					class="password-code"  prop="code"
					:class="{ 'is-error': formMsg.codeMsg != '' }"
				>
					<el-input
						v-model="form.code"
						prop="code"
						placeholder="请输入验证码"
						maxlength="6"
					></el-input>
				
					<el-button
						@click="getCode(2)"
						:disabled="codeText !== '获取验证码'"
						>{{ codeText }}</el-button
					>
				</el-form-item>
				<el-form-item   prop="password"  :class="{ 'is-error': formMsg.passwordMsg != '' }">
					<el-input
						v-model="form.password"
						placeholder="请输入密码"
						show-password
					></el-input>
				
				</el-form-item>
				<el-form-item prop="checkPassword"   :class="{ 'is-error': formMsg.checkPasswordMsg != '' }">
					<el-input
						v-model="form.checkPassword"
						placeholder="请再次输入密码"
						show-password
					></el-input>
				</el-form-item>

				<el-button
					type="primary"
					class="password-save"
					@click="passSub"
					ref="keyEN"
					>保存</el-button
				>
			</el-form>
		</div>
	</div>
</template>

<script>
	export default {
		name: "password-app",
		data() {
					// 电话验证
					function  phoone(rule,value,callback){
					let userinfo = JSON.parse(localStorage.getItem('userInfo'))
					let reg =/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/	
						 if(value === '' || value===undefined || value == null){
							 callback(new Error("电话不能为空"))
						 }
						 else{
							 if(!reg.test(value) ){
								 callback(new Error("请注意号码是否错误或不是当前账号注册号码 "))
							 }else{
								 callback()
							 }
						 }
					}
					let that = this
					// 二次密码验证
					function checkPasswords(rule,value,callback){
						if(value === that.form.password){
							callback()
						}
						else{		
								callback(new Error("重复密码不一致，请重新输入"))
						}	
					
					}	


			return {


					form: {
					phone: "",
					code: "",
					password: "",
				v: "",
				checkPassword:""
				},
				
				formMsg: {
					phoneMsg: "",
					passwordMsg: "",
					checkPasswordMsg: "",
					codeMsg: "",
				},
				formRule: {
					phone:[	{validator:phoone,trigger:'blur'}],
				
					password:[{required:true,message:'密码不能为空',trigger:'blur'},
										{min:6, max:12, message:'密码格式错误，密码为6-12位',trigger:'blur'}],
					code:[{required:true,message:"验证码不能为空",trigger:'blur'},
							{min:6,max:6,message:"验证码格式错误,6位数验证码",trigger:"blur" }],
					checkPassword:[
												{required:true,message:"密码不能为空",trigger:'blur'},
												{validator:checkPasswords,trigger:'blur'},],

				},
				codeText: "获取验证码",
			};
		},
		methods: {
			
			// 忘记密码提交
		   	passSub() {
					 let that = this
				 	 this.$refs['Verify'].validate( async valid =>{
						if(this.form.phone==='',this.form.checkPassword==='',this.form.password==='',this.form.code===''){
						}
						else{
					if(valid){			
								try{
								//console.log("1111")
							  const   {data:res} = await that.$api.userForgoPassword({mobile:that.form.phone,password:that.form.password,code:that.form.code})
								//console.log(res)
								that.$message.success("修改成功")	
								that.$router.go(0);
								}catch(e){
								that.$message.error("验证码错误请重新输入")	
								
								}
						}		
						else{
							that.$message.error("格式错误请重新输入")
							that.$refs['Verify'].resetFields()

						}
						}
						


					})
					

			// if(null){
			// 		this.$message.error('asdasd ')
			// 		return
				// }
				// //
				// return 
				// var that = this;
				// if (this.form.phone == "") {
				// 	this.formMsg.phoneMsg = "请输入手机号码";
				// } else {
				// 	if (!this.checkMobile(this.form.phone)) {
				// 		this.formMsg.phoneMsg = "请输入正确的手机号码";
				// 	} else {
				// 		this.formMsg.phoneMsg = "";
				// 		if (this.form.code == "") {
				// 			this.formMsg.codeMsg = "请输入验证码";
				// 		} else {
				// 			this.formMsg.codeMsg = "";
				// 			if (this.form.password == "") {
				// 				this.formMsg.passwordMsg = "请输入密码";
				// 			} else {
				// 				if (this.form.password.length < 6) {
				// 					this.formMsg.passwordMsg = "密码不能少于6位";
				// 				} else if (!this.checkPass(this.form.password)) {
				// 					this.formMsg.passwordMsg = "密码必须是数字或者字母";
				// 				} else {
				// 					this.formMsg.passwordMsg = "";
				// 					if (this.form.checkPassword == "") {
				// 						this.formMsg.checkPasswordMsg = "请再次输入密码";
				// 					} else {
				// 						if (this.form.checkPassword !== this.form.password) {
				// 							this.formMsg.checkPasswordMsg = "两次输入密码不一致";
				// 						} else {
				// 							this.formMsg.checkPasswordMsg = "";
				// 							var param = {
				// 								mobile: this.form.phone,
				// 								password: this.form.password,
				// 								notpassword: this.form.checkPassword,
				// 								code: this.form.code,
				// 							};
				// 							this.$post("forgetPas", param).then((res) => {
				// 								if (res.code == 0) {
				// 									this.formMsg.phoneMsg = res.msg;
				// 								} else if (res.code == 100010) {
				// 									this.formMsg.codeMsg = res.msg;
				// 								} else if (res.code == 1) {
				// 									localStorage.setItem("user_id", "");
				// 									localStorage.setItem("user_name", "");
				// 									localStorage.setItem("user_image", "");
				// 									this.$message({
				// 										message: res.msg,
				// 										type: "success",
				// 										showClose: true,
				// 										onClose() {
				// 											that.$router.push("/");
				// 											that.$router.go(0);
				// 										},
				// 									});
				// 									setTimeout(() => {
				// 										that.$router.push("/");
				// 										that.$router.go(0);
				// 									}, 3000);
				// 								}
				// 							});
				// 						}
				// 					}
				// 				}
				// 			}
				// 		}
				// 	}
				// }
			},
			//验证手机号
			// checkMobile(str) {
			// 	let re = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
			// 	if (re.test(str)) {
			// 		return true;
			// 	} else {
			// 		return false;
			// 	}
			// },
			// 验证密码
			// checkPass(str) {
			// 	let re = /^[0-9a-zA-Z]+$/;
			// 	if (re.test(str)) {
			// 		return true;
			// 	} else {
			// 		return false;
			// 	}
			// },
			// 获取验证码
	 getCode(index) {
				//console.log("获取验证码")
				let that = this
				let userinfo = JSON.parse(localStorage.getItem('userInfo'))
				//  判断电话是否格式正确
			  this.$refs['Verify'].validateField('phone',  async  phoneErrot=>{
				if(!phoneErrot){
										const	{data:res}  = await that.$api.getMobileCode({mobile:that.form.phone,status:index})
										that.$message.success("发送成功")	
										//console.log(res)
					}
					else{
						that.form.phone=''
						that.$message.error("请输入正确电话号码")
					}
				})	
				},

				keyupEnter(){
						this.$refs['keyEN'].keyup.Enter=passSub()
				},


			 
				// if (this.form.phone == "") {
				// 	this.formMsg.phoneMsg = "请输入手机号码";
				// } else {
				// 	if (!this.checkMobile(this.form.phone)) {
				// 		this.formMsg.phoneMsg = "请输入正确的手机号码";
				// 	} else {
				// 		this.formMsg.phoneMsg = "";
				// 		var i = 31;
				// 		var that = this;
				// 		if ((that.codeText = "获取验证码")) {
				// 			var param = {
				// 				mobile: this.form.phone,
				// 				type: index,
				// 				type_saction: index,
				// 			};
				// 			this.$get("capt", param).then((res) => {
				// 				if (res.code == 0) {
				// 					this.formMsg.phoneMsg = res.msg;
				// 				} else {
				// 					this.$message({
				// 						showClose: true,
				// 						message: "验证码发送成功！",
				// 						type: "success",
				// 					});
				// 					var timer = setInterval(() => {
				// 						i--;
				// 						that.codeText = i + "秒后重试";
				// 						0;
				// 						if (i < 0) {
				// 							clearInterval(timer);
				// 							that.codeText = "获取验证码";
				// 							i = 31;
				// 						}
				// 					}, 1000);
				// 				}
				// 			});
				// 		} else {
				// 		}
				// 	}
				// }
		
			// 绑定回车事件
			//  keyupEnter() {
			//  	var that = this;
			// 	document.onkeydown = function (e) {
			//  		let key = window.event.keyCode;
			//  		if (key == 13) {
			// 			that.passSub();
			// 		}
			//  	};
			//  },
			//重置
			// resetForm() {
			// 	this.form = {
			// 		phone: "",
			// 		password: "",
			// 		checkPassword: "",
			// 		code: "",
			// 	};
			// 	this.resetMsg();
			// },
		// 	resetMsg() {
		// 		this.formMsg = {
		// 			phoneMsg: "",
		// 			passwordMsg: "",
		// 			checkPasswordMsg: "",
		// 			codeMsg: "",
		// 		};
		// 	},
		// },
		created() {
			// 绑定回车事件
			this.keyupEnter();
		},
		// watch: {
		// 	form: {
		// 		handler(newValue, oldValue) {
		// 			this.resetMsg();
		// 		},
		// 		deep: true,
		// 	},
		// },
	}
	}
</script>

<style scoped>
	.password {
		padding: 0 40px;
	}
	.password .el-form {
		padding: 0;
	}
	.password .el-form-item__label {
		font-size: 16px;
		color: #333;
	}
	.password .el-input {
		width: 300px;
		color: #333;
	}
	.password .password-code .el-input {
		width: 180px;
		color: #333;
		margin-right: 20px;
	}
	.password .password-code .el-button {
		width: 100px;
		padding: 12px 0;
		border-color:#e60012;
		color:#e60012;
	}
	.password .password-code .is-disabled {
		color: #c0c4cc;
		cursor: not-allowed;
		background-image: none;
		background-color: #ffffff;
		border-color: #ebeef5;
	}

	.password .el-form-item {
		padding: 30px 0;
		margin-bottom: 0;
		border-bottom: 1px dashed #ebebeb;
	}
	.password-save {
		width: 300px;
		margin-top: 30px;
	}
</style>
